module.exports = __webpack_public_path__ + "media/images/access_contact_photo-5a8c16d267ffcaaf1e44330aa3d7528e.png";